import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "leftContent"];
import { Component } from 'react';
import styled from 'foundations-theming/utils';
import { DialogHeader } from '../DialogHeader';
import { callIfPossible } from '../../utils/functions';
import { PanelNavigatorContext } from '../../context/PanelNavigatorContext';
import { RegistersPanelHeader } from '../../context/PanelComponentRegistrationContext';
import { StyledDialogHeader } from '../DialogHeader/DialogHeader';
import { StyledSection } from '../Section/Section';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LeftContentWrapper = styled.div.withConfig({
  displayName: "PanelHeader__LeftContentWrapper",
  componentId: "xms1vx-0"
})(({
  theme
}) => {
  // color and space are tokenized, position, opacity, and size
  // do not have available tokens at the time of writing
  return {
    position: 'relative',
    left: '-12px',
    marginRight: theme.space['700'],
    '&::after': {
      backgroundColor: theme.color['fill-surface-default'],
      content: '""',
      height: '32px',
      opacity: 0.5,
      position: 'absolute',
      right: '-21px',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '1px'
    }
  };
});
const StyledPanelHeaderWrapper = styled.div.withConfig({
  displayName: "PanelHeader__StyledPanelHeaderWrapper",
  componentId: "xms1vx-1"
})(({
  theme
}) => {
  return {
    [`${StyledDialogHeader}`]: {
      display: 'flex',
      flexDirection: 'column',
      backgroundImage: `linear-gradient(-303deg, ${theme.color['temp-do-not-use-fill-secondary-default']}, ${theme.color['fill-positive-default']})`,
      borderRadius: theme.borderRadius['0'],
      [`+ ${StyledSection}`]: {
        paddingBlockStart: theme.space['1000']
      },
      [`h1, h2, h3, h4, h5, h6`]: {
        margin: theme.space['0']
      }
    },
    [`+ ${StyledSection}`]: {
      paddingBlockStart: theme.space['600']
    }
  };
});
export class PanelHeader extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      currentPanel: null
    };
  }
  componentDidMount() {
    const currentPanel = callIfPossible(this.context.getCurrentPanel);
    if (currentPanel) {
      this.setState({
        currentPanel
      });
    }
  }
  render() {
    const _this$props = this.props,
      {
        children,
        leftContent
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      currentPanel
    } = this.state;
    const computedLeftContent = leftContent || callIfPossible(this.context.renderNavigation, currentPanel);
    return /*#__PURE__*/_jsx(StyledPanelHeaderWrapper, {
      children: /*#__PURE__*/_jsxs(DialogHeader, Object.assign({}, rest, {
        children: [/*#__PURE__*/_jsx(RegistersPanelHeader, {}), computedLeftContent && /*#__PURE__*/_jsx(LeftContentWrapper, {
          children: computedLeftContent
        }), children]
      }))
    });
  }
}
PanelHeader.contextType = PanelNavigatorContext;